import { observer } from 'mobx-react-lite'
import React from 'react'
import { MDBAlert } from 'mdbreact'
import SubscriptionsStore from './../../Subscriptions.store'
import DateService from './../../../../shared/services/Date.service'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import UsertypeService from './../../../../shared/services/Usertype.service'

const ucwords = (str) =>
  str.replace(/^([a-z])|[\s_]+([a-z])/g, ($1) => $1.toUpperCase())

const renderNonAgent = (User) => {
  let usertype = ucwords(
    (
      (User?.get('usertype_id') &&
        UsertypeService.idToName(User?.get('usertype_id'))) ||
      ''
    ).replace(/-/, ' ')
  )

  return (
    <MDBAlert className="text-center" color="warning">
      You do not have an <strong>Agent</strong> account
      {usertype ? ` (${usertype})` : ''}.
      <br />
      You are inelligle for account subscriptions.
    </MDBAlert>
  )
}

const renderLegacySubscription = () => {
  return (
    <MDBAlert className="text-center" color="success">
      Your agent subscription is <strong>active</strong>.
    </MDBAlert>
  )
}

const renderPreparingAccount = () => {
  return (
    <MDBAlert className="text-center" color="secondary">
      Preparing Account...
    </MDBAlert>
  )
}

const renderInactiveSubscription = () => {
  return (
    <MDBAlert className="text-center" color="warning">
      You do not have an active subscription.
    </MDBAlert>
  )
}

const renderInvalidPayment = () => {
  return (
    <MDBAlert className="text-center" color="danger">
      You must add a valid payment method before you can upgrade your
      subscription.
    </MDBAlert>
  )
}

const renderCanceledSubscription = (canceledAt) => {
  return (
    <MDBAlert className="text-center" color="warning">
      Your subscription was <strong>canceled</strong> on{' '}
      <strong>{DateService.dateOnlyToString(canceledAt, 'MM/DD/YYYY')}</strong>.
    </MDBAlert>
  )
}

const renderActiveSubscription = (startedAt) => {
  return (
    <MDBAlert className="text-center" color="success">
      Your Signature Agent subscription is <strong>active</strong>
      {UserProfileService.isAssumed() &&
      UserProfileService.isA(
        ['system-admin', 'internal-admin', 'internal-staff'],
        true
      ) ? (
        <>
          &nbsp;since{' '}
          <strong>
            {DateService.dateOnlyToString(startedAt, 'MM/DD/YYYY')}
          </strong>
        </>
      ) : (
        <></>
      )}
      .
    </MDBAlert>
  )
}

const SubscriptionStatus = () => {
  const {
      User,
      subSource,
      customerId,
      subscriptionId,
      subscription,
      paymentMethods,
      isActive,
      isCanceled,
    } = SubscriptionsStore,
    status = subscription?.sub_status

  if (User?.isA('non-agent')) return renderNonAgent(User)

  if (subSource && subSource?.merchant !== 'stripe' && subSource?.canceled_at)
    return renderLegacySubscription()

  if (!subscriptionId) {
    if (!customerId) return renderPreparingAccount()

    return (
      <>
        {renderInactiveSubscription()}
        {paymentMethods && paymentMethods.length ? (
          <></>
        ) : (
          renderInvalidPayment()
        )}
      </>
    )
  }

  if (isCanceled()) return renderCanceledSubscription(subscription?.canceled_at)

  if (isActive()) return renderActiveSubscription(subscription?.started_at)

  if (status) {
    return (
      <MDBAlert
        className="text-center"
        color={
          status === 'active'
            ? 'success'
            : status === 'inactive'
            ? 'warning'
            : 'danger'
        }
      >
        Your Signature Agent subscription is <strong>{status}</strong>.
      </MDBAlert>
    )
  }

  return <></>
}

export default observer(SubscriptionStatus)
